module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-7-68d95209f3f17d87519937600ae690ec.jpg";